function getDateFromArray(dateArray) {
    let year = dateArray[0]
    let month = dateArray[1]
    let day = dateArray[2]
  
    return new Date(year, month - 1, day, 8)
  }
  
  export default getDateFromArray